import { render, staticRenderFns } from "./paymentType.vue?vue&type=template&id=fdf210ea&"
import script from "./paymentType.vue?vue&type=script&lang=js&"
export * from "./paymentType.vue?vue&type=script&lang=js&"
import style0 from "./paymentType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdf210ea')) {
      api.createRecord('fdf210ea', component.options)
    } else {
      api.reload('fdf210ea', component.options)
    }
    module.hot.accept("./paymentType.vue?vue&type=template&id=fdf210ea&", function () {
      api.rerender('fdf210ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/paymentType.vue"
export default component.exports